import React, { useState, useEffect } from "react";

export default function BackdropFilterOnce({ description, videoUrl, fetchingModuleInfo = false, disabled, planModuleSlug }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Only show if disabled is false and hasn't been shown before in this session for this specific module
        if (!disabled && planModuleSlug) {
            const sessionKey = `backdropFilterOnceShown_${planModuleSlug}`;
            const hasBeenShown = sessionStorage.getItem(sessionKey);
            if (!hasBeenShown) {
                setIsVisible(true);
                sessionStorage.setItem(sessionKey, 'true');
            }
        }
    }, [disabled, planModuleSlug]);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="d-flex flex-column align-items-center justify-content-center" 
             style={{ height: '100vh', width: '100%', left: '0', top: '0', zIndex: '9999', position: 'fixed', backdropFilter: 'blur(5px)', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="card shadow-lg text-white position-relative" 
                 style={{ minHeight: '300px', minWidth: '300px', background: '#3699ff' }}>
                
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="btn btn-sm btn-light position-absolute"
                    style={{ top: '10px', right: '10px', zIndex: '10000' }}
                >
                    Close
                </button>

                <div className="card-body d-flex flex-column justify-content-center" style={{ minHeight: '200px' }}>
                    {fetchingModuleInfo && (
                        <div className="h5 text-center">
                            <div className="spinner-border text-light" role="status">
                            </div>
                        </div>
                    )}
                    {!fetchingModuleInfo && description && description !== "" && (
                        <div className="h5 text-center"
                            dangerouslySetInnerHTML={{
                                __html: description
                            }}>
                        </div>
                    )}
                    {!fetchingModuleInfo && videoUrl && videoUrl !== "" && (
                        <video src={videoUrl} autoPlay controls style={{ width: '700px', maxHeight: '700px', objectFit: 'contain' }} />
                    )}
                    {!fetchingModuleInfo && (!description || description === "") && (!videoUrl || videoUrl === "") && (
                        <div className="h5 text-center">
                            <p>
                                Welcome! This feature is now available to you. <br />
                                Explore the powerful capabilities and enhance your workflow. <br />
                                Get started with this amazing tool to boost your productivity. <br />
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
